<template>
    <div class="tradingCond">
        <p class="title body-6-bold">{{ title }}</p>
        <div class="containerOpt">
            <div class="opt" v-for="(item, index) in cards" :key="index">
                <div class="icon">
                    <span class="material-symbols-outlined" translate="no">{{ item.icon }}</span>
                </div>
                <div>
                    <p class="subtitle body-4">{{ $t(item.title) }}</p>
                   <!--  <p class="desc-opt body-5">{{ $t(item.description) }}</p> -->
                    <a v-if="item.url" class="link-6" :href="localPath(item.url)" target="_blank" rel="noopener noreferrer">
                    {{ $t(item.link) }}
                </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

const props = defineProps({
    title: String,
    cards: {
        type: Array,
        required: true,
    }
});

const localPath = useLocalePath();
</script>